module.exports = {
	xsmall: 480,
	small: 768,
	medium: 992,
	large: 1200
};